import {
    Card,
    CardContent,
    IconButton,
    Link as MuiLink,
    Stack,
    Table,
    TableCell,
    TableRow,
    TextField,
    Tooltip,
    Typography
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SearchIcon from "@mui/icons-material/Search";
import {LoadingButton} from "@mui/lab";
import {useContext, useState} from "react";
import {useParams} from "react-router-dom";
import {format} from "date-fns";
import {useSearchClanByNameCMMutation} from "../../core/api/clockmaker-clans-api";
import {SnackBarContext} from "../../snackBarProvider";


const ClanSearch = () => {

    const {game} = useParams();
    const clansUrl = (id) => `/${game}/clans/${id}`;

    const useSnackBars = () => useContext(SnackBarContext);
    const {addAlert} = useSnackBars();

    const [searchClan, searchClanResponse] = useSearchClanByNameCMMutation();
    const [searchName, setSearchName] = useState('');
    const searchResult = searchClanResponse.data;

    const handleSearch = async () => {
        const response = await searchClan(searchName.trim());
        if (response.hasOwnProperty('error')) {
            addAlert({text: response.error?.data?.message || 'Clan not found', type: 'error'});
        }
    };

    return (
        <Card>
            <CardContent>
                <Typography variant="h5" gutterBottom>Search Clan by Name</Typography>
                <Stack direction="row" spacing={1} sx={{
                    alignItems: "center"
                }}>
                    <TextField
                        label="Clan Name" size="small" value={searchName}
                        onChange={(e) => setSearchName(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter' && searchName.trim()) handleSearch(); }}
                    />
                    <LoadingButton
                        loading={searchClanResponse.isLoading}
                        variant="outlined" color="info"
                        startIcon={<SearchIcon/>}
                        disabled={!searchName.trim()}
                        onClick={handleSearch}>
                        Search
                    </LoadingButton>
                </Stack>

                {searchResult && (
                    <>
                        <Card sx={{mt: 2}}>
                            <Table>
                                <TableRow>
                                    <TableCell>id</TableCell>
                                    <TableCell>{searchResult.id}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>{searchResult.name}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Description</TableCell>
                                    <TableCell>{searchResult.description}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Country</TableCell>
                                    <TableCell>{searchResult.country}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Creator</TableCell>
                                    <TableCell>
                                        {searchResult.creator && (
                                            <MuiLink href={clansUrl(searchResult.creator)} target="_blank" rel="noopener" underline="hover">
                                                {searchResult.creator}
                                            </MuiLink>
                                        )}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Owner</TableCell>
                                    <TableCell>
                                        {searchResult.owner && (
                                            <MuiLink href={clansUrl(searchResult.owner)} target="_blank" rel="noopener" underline="hover">
                                                {searchResult.owner}
                                            </MuiLink>
                                        )}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Level</TableCell>
                                    <TableCell>{searchResult.level}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Members</TableCell>
                                    <TableCell>{searchResult.member_count}</TableCell>
                                </TableRow>
                            </Table>
                        </Card>

                        <Card sx={{mt: 2}}>
                            <CardContent>
                                <Typography sx={{fontSize: 16}}>
                                    Members
                                </Typography>
                            </CardContent>
                            <Table>
                                <TableRow>
                                    <TableCell>id</TableCell>
                                    <TableCell>name</TableCell>
                                    <TableCell>level</TableCell>
                                    <TableCell>Help Score</TableCell>
                                    <TableCell>Last Activity</TableCell>
                                    <TableCell>cheater</TableCell>
                                </TableRow>
                                {(searchResult.members || []).map(item => (
                                    <TableRow>
                                        <TableCell sx={{maxWidth: 150}}>
                                            <Stack direction="row" spacing={0.5} sx={{alignItems: 'center'}}>
                                                <MuiLink
                                                    href={clansUrl(item.id)} target="_blank" rel="noopener" underline="hover"
                                                    sx={{wordBreak: 'break-all', minWidth: 0}}>
                                                    {item.id}
                                                </MuiLink>
                                                <Tooltip title="Open state in new tab">
                                                    <IconButton
                                                        size="small" aria-label="open state in new tab"
                                                        href={clansUrl(item.id)} target="_blank" rel="noopener">
                                                        <OpenInNewIcon fontSize="inherit"/>
                                                    </IconButton>
                                                </Tooltip>
                                            </Stack>
                                        </TableCell>
                                        <TableCell>{item.name}</TableCell>
                                        <TableCell>{item.level}</TableCell>
                                        <TableCell>{item.helpScore}</TableCell>
                                        <TableCell>
                                            {item.last_activity ? format(item.last_activity, "dd.MM.yyyy HH:mm:ss") : ''}
                                        </TableCell>
                                        <TableCell>{item.cheater === true ? <strong>Yes</strong> : 'No'}</TableCell>
                                    </TableRow>
                                ))
                                }
                            </Table>
                        </Card>
                    </>
                )}
            </CardContent>
        </Card>
    );
}

export default ClanSearch
